export const esLocalHost = () => {
    if(window.location == undefined || window.location == null) return false;
    return window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
}


// WEBPACK FOOTER //
// ./src/utils/ambiente.js